import { Fragment, useEffect, useState } from "react";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";

import ActivateAccount from "./auth/create/ActivateAccount";
import AdminBottomNavConfig from "./template/AdminBottomNavConfig";
import AdsListPage from "./pages/marketing/announcement/AdsListPage";
import Advances from "./pages/cash-closing/advances/Advances";
import AnamnesePage from "./pages/atendimento/anamnese/pages/anamnese/AnamnesePage";
import CashClosingDetails from "./pages/cash-closing/cash-details/CashClosingDetails";
import CashClosingPendingDetail from "./pages/cash-closing/cash-closing-pending/CashClosingPendingDetail";
import CashRegisterDashboard from "./pages/cash-register/CashRegisterDashboard";
import CategoriesAnServices from "./pages/services/CategoriesAndServices";
import ChatbotConfig from "./pages/chatbot/ChatbotConfig";
import ClubPaymentGatewayPage from "./pages/atendimento/club/pages/payment-gateway/ClubPaymentGatewayPage";
import ClubPlanCustomersPage from "./pages/atendimento/club/pages/club-plan-customer/ClubPlanCustomersPage";
import ClubPlanListPage from "./pages/atendimento/club/pages/list/ClubPlanListPage";
import Commands from "./pages/commands/Commands";
import CommandsReception from "./pages/commands/CommandReception";
import Companies from "./pages/company/Companies";
import ConfirmScheduling from "./pages/scheduler/pages/confirm-scheduling/ConfirmScheduling";
import { ContractInactiveModal } from "./commons/modal/ContractInactiveModal";
import { ContractInvalidModal } from "./commons/modal/ContractInvalidModal";
import CreateAccout from "./auth/create/CreateAccout";
import CreateAd from "./pages/marketing/announcement/CreateAd";
import Customers from "./pages/customer/Customers";
import EmployeeInvite from "./pages/employee/pages/EmployeeInvite";
import Employess from "./pages/employee/Employees";
import ExternalTransactions from "./pages/external-transactions/ExternalTransactions";
import Feedback from "./pages/feedback/Feedback";
import FormBuilderPage from "./pages/atendimento/anamnese/pages/forms/FormBuilderPage";
import FormResponseViewPage from "./pages/atendimento/anamnese/pages/anamnese/FormResponseViewPage";
import FormTemplatesListPage from "./pages/atendimento/anamnese/pages/forms/FormTemplatesListPage";
import GeradorReelsPage from "./pages/instagram/reels/GeradorReelsPage";
import GrossTotalDetails from "./pages/report/gross-total-detail/GrossTotalDetails";
import HallPointsConfigurations from "./pages/HallPoints/configuracoes/HallPointsConfigurations";
import HallPointsSimulator from "./pages/HallPoints/simulator/HallPointsSimulator";
import Hallie from "./pages/hallie/Hallie";
import Home from "./pages/home/Home";
import Install from "./auth/Install";
import Login from "./auth/login/Login";
import Machines from "./pages/machine/Machines";
import MenuPersonalizar from "./pages/menu-personalizar/MenuPersonalizar";
import MetaCallback from "./pages/marketing/MetaCallback";
import MetaCallbackBridge from "./pages/marketing/MetaCallbackBridge";
import MetaConnection from "./pages/marketing/MetaConnection";
import MyAccount from "./pages/my-account/MyAccount";
import NotificationsSettings from "./pages/my-account/NotificationsSettings";
import PackageCustomersPage from "./pages/atendimento/package/pages/package-customers/PackageCustomersPage";
import PackagesPage from "./pages/atendimento/package/pages/PackagesPage";
import PermissionError from "./PermissionError";
import Plans from "./pages/signature/Plans";
import PrivacyPolicy from "./PrivacyPolicy";
import PrivateRoute from "./auth/PrivateRoute";
import ProductCommissionDetailsPage from "./pages/stock/components/ProductCommissionDetailsPage";
import ProductCommissionsPage from "./pages/stock/ProductCommissionsPage";
import ProductMovementHistoryPage from "./pages/stock/ProductMovementHistoryPage";
import ProductsPage from "./pages/stock/ProductsPage";
import Promotions from "./pages/promotions/Promotions";
import ProtectedRoute from "./ProtectedRoute";
import ProtocolsPage from "./pages/atendimento/anamnese/pages/protocols/ProtocolsPage";
import RecoveryPassword from "./auth/recovery-password/RecoveryPassword";
import RecurringSchedule from "./pages/scheduler/pages/recurring-schedule/RecurringSchedule";
import ReelsHistoryPage from "./pages/instagram/reels/ReelsHistoryPage";
import Report from "./pages/report/Report";
import ReportCustomer from "./pages/report-full/ReportCustomer";
import ReportDetail from "./pages/report-full/ReportDetail";
import ReportFull from "./pages/report-full/ReportFull";
import ReportService from "./pages/report-full/ReportService";
import RewardConfiguration from "./pages/HallPoints/rewards/HallPointRewards";
import { RuntimeProvider } from "./commons/runtime/RuntimeContext";
import Scheduler from "./pages/scheduler/pages/scheduler/new-version/Scheduler";
import SchedulerClearances from "./pages/scheduler/pages/SchedulerClearances";
import SchedulerConfig from "./pages/scheduler/SchedulerConfig";
import SchedulerLayoutConfig from "./pages/scheduler/pages/SchedulerLayoutConfig";
import Splash from "./commons/pages/splash/Splash";
import SsoRedirect from "./auth/SsoRedirect";
import StockCommissionDetail from "./pages/stock/StockCommissionDetail";
import Stocks from "./pages/stock/Stocks";
import SuggestionService from "./pages/services/suggestion-service/SuggestionService";
import Template from "./template/Template";
import TrichoAnalysisListPage from "./pages/atendimento/anamnese/pages/tricoscopica/list/TrichoAnalysisListPage";
import TrichoAnalysisPage from "./pages/atendimento/anamnese/pages/tricoscopica/TrichoAnalysisPage";
import UpadatePassword from "./auth/update-password/UpdatePassword";
import VisitsDetails from "./pages/report/visits-details/VisitsDetails";
import WhatsAppConnectPage from "./pages/chatbot/WhatsAppConnectPage";

const LOCAL_STORAGE_KEY = "hallapp-menu-config";

export const AppRoutes = () => {
  const [showContractModal, setShowContractModal] = useState(false);
  const [showContractInvalidModal, setShowContractInvalidModal] = useState(false);
  const [defaultPath, setDefaultPath] = useState("/");

  useEffect(() => {
    const handleContractInactive = () => setShowContractModal(true);
    const handleContractInvalid = () => setShowContractInvalidModal(true);

    window.addEventListener("contract-inactive", handleContractInactive);
    window.addEventListener("contract-invalid", handleContractInvalid);

    return () => {
      window.removeEventListener("contract-inactive", handleContractInactive);
      window.removeEventListener("contract-invalid", handleContractInvalid);
    };
  }, []);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed?.defaultPath) {
          // garante que começa com "/"
          const dp = String(parsed.defaultPath);
          setDefaultPath(dp.startsWith("/") ? dp : `/${dp}`);
        } else {
          setDefaultPath('/inicio');
        }
      } else {
        setDefaultPath('/inicio');
      }
    } catch (_) {
      console.warn("Erro ao ler defaultPath do menu (AppRoutes)");
    }
  }, []);

  // caso especial fora do HashRouter
  if (window.location.pathname === "/meta/callback") {
    return <MetaCallbackBridge />;
  }

  return (
    <HashRouter>
      <RuntimeProvider>
        <Fragment>
          <ContractInactiveModal show={showContractModal} onHide={() => setShowContractModal(false)} />
          <ContractInvalidModal show={showContractInvalidModal} onHide={() => setShowContractInvalidModal(false)} />

          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/instalar" element={<Install />} />
            <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
            <Route path="/a/:token" element={<ConfirmScheduling />} />
            <Route path="/splash" element={<Splash />} />
            <Route path="/sso" element={<SsoRedirect />} />
            <Route path="/" element={<PrivateRoute />}>
              <Route element={<Template />}>
                {/* default configurado */}
                <Route index element={<Navigate to={defaultPath} replace />} />

                {/* Rotas */}
                <Route path="inicio" element={<Home />} />
                <Route path="notificacoes" element={<NotificationsSettings />} />
                <Route path="menu-personalizar" element={<MenuPersonalizar />} />
                <Route path="minha-conta" element={<MyAccount />} />

                <Route
                  path="meus-estabelecimentos"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <Companies />
                    </ProtectedRoute>
                  }
                />

                <Route path="agenda-semanal" element={<SchedulerConfig />} />
                <Route
                  path="/clube/pagamentos"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <ClubPaymentGatewayPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/clubes"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <ClubPlanListPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/clubes/:clubPlanId/clientes"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <ClubPlanCustomersPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/pacotes/:packageId/clientes"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <PackageCustomersPage />
                    </ProtectedRoute>
                  }
                />

                <Route path="agenda-semanal" element={<SchedulerConfig />} />

                <Route
                  path="funcionarios"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <Employess />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="pacotes"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <PackagesPage />
                    </ProtectedRoute>
                  }
                />


                <Route
                  path="promotions"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <Promotions />
                    </ProtectedRoute>
                  }
                />


                <Route
                  path="forms"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <FormTemplatesListPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="protocolos"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <ProtocolsPage />
                    </ProtectedRoute>
                  }
                />


                <Route
                  path="anamnese"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <AnamnesePage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="analise-tricoscopica"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <TrichoAnalysisPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="analise-tricoscopica/:id"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <TrichoAnalysisPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="analise-tricoscopica/anamnese/:anamneseId"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <TrichoAnalysisPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="analises"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <TrichoAnalysisListPage />
                    </ProtectedRoute>
                  }
                />


                <Route
                  path="anamnese/:id"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <FormResponseViewPage />
                    </ProtectedRoute>
                  }
                />



                <Route
                  path="config-form"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <FormBuilderPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="config-form/:id"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <FormBuilderPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="config-bottom-menu"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <AdminBottomNavConfig />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="feedback"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <Feedback />
                    </ProtectedRoute>
                  }
                />

                <Route path="comandas" element={<Commands />} />
                <Route path="comandas-recepcao" element={<CommandsReception />} />
                <Route path="servicos" element={<CategoriesAnServices />} />
                <Route path="servicos-sugeridos" element={<SuggestionService />} />

                <Route
                  path="hallie"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <Hallie />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="marketing/conectar"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <MetaConnection />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="meta/callback"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <MetaCallback />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="marketing/criar-anuncio"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <CreateAd />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="marketing/meus-anuncios"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <AdsListPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="marketing/editar-anuncio"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <CreateAd />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="instagram/gerador-reels"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <GeradorReelsPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="instagram/gerador-reels/historico"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <ReelsHistoryPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="maquininha"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <Machines />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="whats-config"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <WhatsAppConnectPage />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="clientes"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <Customers />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="relatorio"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <Report />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="relatorio-completo"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <ReportDetail />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="relatorio-servico"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <ReportService />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="relatorio-geral"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <ReportFull />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="relatorio-geral/gross-detail"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <GrossTotalDetails />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="relatorio-geral/visit-detail"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <VisitsDetails />
                    </ProtectedRoute>
                  }
                />




                <Route
                  path="relatorio-cliente"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <ReportCustomer />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="hallpoints-configuracao"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <HallPointsConfigurations />
                    </ProtectedRoute>
                  }
                />

                <Route path="hallpoints-recompensas" element={<RewardConfiguration />} />

                <Route
                  path="hallpoints-simulador"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <HallPointsSimulator />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="external-transactions"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <ExternalTransactions />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="fechamento-caixa"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <CashRegisterDashboard />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="fechamento-caixa/pendente"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <CashClosingPendingDetail />
                    </ProtectedRoute>
                  }
                />

                <Route path="estoque" element={<ProductsPage />} />
                <Route path="whatsapp-connect" element={<WhatsAppConnectPage />} />

                <Route path="produtos/:productId/movimentos" element={<ProductMovementHistoryPage />} />
                <Route path="produtos/comissoes" element={<ProductCommissionsPage />} />
                <Route
                  path="/produtos/comissoes/:employeeId"
                  element={<ProductCommissionDetailsPage />}
                />

                <Route
                  path="detalhes-comissao/:employeeId"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <CashClosingDetails />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="adiantamento/:employeeId"
                  element={
                    <ProtectedRoute requiredRole="COMPANY">
                      <Advances />
                    </ProtectedRoute>
                  }
                />

                <Route path="folgas" element={<SchedulerClearances />} />
                <Route path="agenda" element={<Scheduler />} />
                <Route path="configurar-agenda" element={<SchedulerLayoutConfig />} />
                <Route path="assinatura" element={<Plans />} />
                <Route path="agendamento-recorrente" element={<RecurringSchedule />} />
                <Route path="estoque/detalhes/profissional/:employeeId" element={<StockCommissionDetail />} />

                {/* ✅ rota de erro como FILHA */}
                <Route path="erro" element={<PermissionError />} />

                {/* ✅ fallback: rota inválida dentro do app => /inicio (relativo ao layout) */}
                <Route path="*" element={<Navigate to="inicio" replace />} />
              </Route>
            </Route>

            <Route path="/criar-conta" element={<CreateAccout />} />
            <Route path="/convite/:token" element={<EmployeeInvite />} />
            <Route path="/recuperar-senha" element={<RecoveryPassword />} />
            <Route path="/redefinir-senha/:token" element={<UpadatePassword />} />
            <Route path="/ativar-conta/:token" element={<ActivateAccount />} />
          </Routes>
        </Fragment>
      </RuntimeProvider>
    </HashRouter>
  );
};
